import { useContext } from 'react'
import ItemsContext from '../contexts/items-context'

const useItemContext = () => useContext(ItemsContext)

export default useItemContext
